import React from "react";
import { FiX, FiActivity } from "react-icons/fi";

interface ModalHeaderProps {
  readonly exerciseName: string;
  readonly onClose: () => void;
}

export default function ModalHeader({
  exerciseName,
  onClose,
}: ModalHeaderProps) {
  return (
    <div className="relative border-b border-stroke bg-gradient-to-r from-purple-50 via-purple-50 to-purple-50 px-4 sm:px-8 py-4 sm:py-6 dark:border-strokedark dark:from-purple-950/30 dark:via-purple-950/30 dark:to-purple-950/30">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      <button
        onClick={onClose}
        className="absolute right-3 sm:right-6 top-3 sm:top-6 z-10 rounded-lg sm:rounded-xl p-2 sm:p-2.5 text-gray-500 outline-none transition-all active:scale-95 touch-manipulation hover:bg-white hover:text-gray-700 hover:shadow-sm focus-visible:ring-2 focus-visible:ring-purple-500 dark:text-gray-400 dark:hover:bg-boxdark dark:hover:text-gray-200"
        aria-label="Fechar modal"
      >
        <FiX size={20} className="sm:w-6 sm:h-6" />
      </button>

      <div className="relative flex items-start gap-3 sm:gap-5 pr-10 sm:pr-0">
        <div className="relative flex-shrink-0">
          <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-purple-600 to-purple-600 opacity-75 blur-sm"></div>
          <div className="relative flex h-14 w-14 sm:h-20 sm:w-20 items-center justify-center overflow-hidden rounded-full border-2 sm:border-4 border-white bg-purple-600 shadow-xs dark:border-boxdark">
            <FiActivity className="text-white" size={24} />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-lg sm:text-2xl font-bold text-gray-900 dark:text-white truncate">
            {exerciseName}
          </h3>
          <p className="mt-1 text-xs sm:text-sm text-gray-600 dark:text-gray-400">
            Histórico de execuções do exercício
          </p>
        </div>
      </div>
    </div>
  );
}
